module.exports = __webpack_public_path__ + "static/intro-b8fec2708eef656350b870701d641c25.jpg";